<script>
import SearchResultItem from './ArticleSearchResultItem.vue';

export default {
  name: 'SearchResults',
  components: {
    SearchResultItem,
  },
  props: {
    articles: {
      type: Array,
      default: () => [],
    },
    isLoading: {
      type: Boolean,
      default: false,
    },
    searchQuery: {
      type: String,
      default: '',
    },
  },
  emits: ['preview', 'insert'],
  data() {
    return {
      collapsedLocales: {},
    };
  },
  computed: {
    showNoResults() {
      return this.searchQuery && this.articles.length === 0;
    },
    articlesByLocale() {
      const grouped = {};
      this.articles.forEach(article => {
        const locale = article.localeName || 'Unknown';
        if (!grouped[locale]) {
          grouped[locale] = [];
        }
        grouped[locale].push(article);
      });
      return grouped;
    },
    localeNames() {
      return Object.keys(this.articlesByLocale).sort();
    },
  },
  methods: {
    handlePreview(id) {
      this.$emit('preview', id);
    },
    handleInsert(id) {
      this.$emit('insert', id);
    },
    toggleLocale(locale) {
      this.collapsedLocales[locale] = !this.collapsedLocales[locale];
      this.$forceUpdate();
    },
    isLocaleCollapsed(locale) {
      return this.collapsedLocales[locale] !== false;
    },
  },
};
</script>

<template>
  <div
    class="flex justify-end h-full gap-1 py-4 overflow-y-auto bg-n-background"
  >
    <div class="flex flex-col w-full gap-1">
      <div
        v-if="isLoading"
        class="text-center flex items-center justify-center px-4 py-8 text-n-slate-10 text-sm"
      >
        {{ $t('HELP_CENTER.ARTICLE_SEARCH_RESULT.SEARCH_LOADER') }}
      </div>
      <div
        v-else-if="showNoResults"
        class="text-center flex items-center justify-center px-4 py-8 text-n-slate-10 text-sm"
      >
        {{ $t('HELP_CENTER.ARTICLE_SEARCH_RESULT.NO_RESULT') }}
      </div>
      <template v-else>
        <div
          v-for="locale in localeNames"
          :key="locale"
          class="flex flex-col gap-1"
        >
          <button
            class="flex items-center justify-between w-full px-4 py-2 text-left bg-n-background hover:bg-n-hover transition-colors border-b border-n-weak"
            @click="toggleLocale(locale)"
          >
            <span class="font-medium text-n-slate-12 text-sm">
              {{ locale }} ({{ articlesByLocale[locale].length }})
            </span>
            <span
              class="text-n-slate-10 transition-transform"
              :class="{ 'rotate-180': !isLocaleCollapsed(locale) }"
            >
              ▼
            </span>
          </button>
          <div v-if="!isLocaleCollapsed(locale)" class="flex flex-col gap-1">
            <SearchResultItem
              v-for="article in articlesByLocale[locale]"
              :id="article.id"
              :key="article.id"
              :title="article.title"
              :body="article.content"
              :url="article.url"
              :category="article.category.name"
              :locale="article.localeName"
              @preview="handlePreview"
              @insert="handleInsert"
            />
          </div>
        </div>
      </template>
    </div>
  </div>
</template>
